var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_4950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.3333C14.5923 18.3333 18.334 14.5916 18.334 9.99992C18.334 5.40825 14.5923 1.66659 10.0007 1.66659C5.40899 1.66658 1.66732 5.40825 1.66732 9.99992C1.66732 14.5916 5.40898 18.3333 10.0007 18.3333ZM10.6257 13.3333C10.6257 13.6749 10.3423 13.9583 10.0007 13.9583C9.65898 13.9583 9.37565 13.6749 9.37565 13.3333L9.37565 9.16659C9.37565 8.82492 9.65899 8.54159 10.0007 8.54159C10.3423 8.54159 10.6257 8.82492 10.6257 9.16659L10.6257 13.3333ZM9.23399 6.34992C9.27565 6.24159 9.33399 6.15825 9.40899 6.07492C9.49232 5.99992 9.58399 5.94158 9.68399 5.89992C9.78399 5.85825 9.89232 5.83325 10.0007 5.83325C10.109 5.83325 10.2173 5.85825 10.3173 5.89992C10.4173 5.94158 10.509 5.99992 10.5923 6.07492C10.6673 6.15825 10.7257 6.24159 10.7673 6.34992C10.809 6.44992 10.834 6.55825 10.834 6.66659C10.834 6.77492 10.809 6.88325 10.7673 6.98325C10.7257 7.08325 10.6673 7.17492 10.5923 7.25825C10.509 7.33325 10.4173 7.39158 10.3173 7.43325C10.1173 7.51658 9.88399 7.51658 9.68399 7.43325C9.58399 7.39158 9.49232 7.33325 9.40899 7.25825C9.33399 7.17492 9.27565 7.08325 9.23399 6.98325C9.19232 6.88325 9.16732 6.77492 9.16732 6.66659C9.16732 6.55825 9.19232 6.44992 9.23399 6.34992Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_4950)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.db781f5a818a860e60106c72bc17cb88.svg";
export { ForwardRef as ReactComponent };